var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        { name: "show", rawName: "v-show", value: _vm.show, expression: "show" }
      ],
      staticClass: "user-count"
    },
    [
      _c("div", { staticClass: "room-group" }, [
        _c("div", { staticStyle: { padding: "10px" } }, [
          _c(
            "div",
            { staticClass: "user-count-item" },
            [
              _c("input-number", {
                attrs: { min: 1, max: 3 },
                model: {
                  value: _vm.guests.room,
                  callback: function($$v) {
                    _vm.$set(_vm.guests, "room", $$v)
                  },
                  expression: "guests.room"
                }
              }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("room")))])
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "middle-line" }, [
          _vm._v(_vm._s(_vm.$t("guest_per_room")))
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { padding: "10px" } },
          [
            _c(
              "div",
              { staticClass: "user-count-item" },
              [
                _c("input-number", {
                  attrs: { min: 1, max: _vm.adult },
                  model: {
                    value: _vm.guests.Adults,
                    callback: function($$v) {
                      _vm.$set(_vm.guests, "Adults", $$v)
                    },
                    expression: "guests.Adults"
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("adult")))])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "user-count-item" },
              [
                _c("input-number", {
                  attrs: { max: _vm.child },
                  on: {
                    plus: function($event) {
                      _vm.plusAge(_vm.guests.Age)
                    },
                    minus: function($event) {
                      _vm.minusAge(_vm.guests.Age)
                    }
                  },
                  model: {
                    value: _vm.guests.Children,
                    callback: function($$v) {
                      _vm.$set(_vm.guests, "Children", $$v)
                    },
                    expression: "guests.Children"
                  }
                }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.guests.Children >= 2
                        ? _vm.$t("children")
                        : _vm.$t("child")
                    )
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _vm._l(_vm.guests.Age, function(i, id) {
              return _c(
                "div",
                {
                  key: id,
                  staticClass: "room-group",
                  staticStyle: { "background-color": "rgba(246,246,246,1)" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "user-count-item" },
                    [
                      _c("input-number", {
                        attrs: { min: 0, max: 12, selectIcon: false },
                        model: {
                          value: i.Age,
                          callback: function($$v) {
                            _vm.$set(i, "Age", $$v)
                          },
                          expression: "i.Age"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("age_name")))])
                    ],
                    1
                  )
                ]
              )
            })
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-651762b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-651762b6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/AirTicket/components/GuestsMenu.vue
// module id = null
// module chunks = 